<template>
  <div class="filter-container">
    <div
      class="filter-header"
      :class="{ 'has-filters': store.hasActiveFilters }"
      @click="current.isCollapsed = !current.isCollapsed"
    >
      <button class="collapsed-button d-flex align-items-center btn btn-primary">
        <span
          class="glyphicon"
          :class="{
            'glyphicon-chevron-up': !current.isCollapsed,
            'glyphicon-chevron-down': current.isCollapsed
          }"
        ></span>
      </button>
      <span class="h3">{{ filterData.title }}</span>

      <span v-if="store.hasActiveFilters">
        <button
          v-for="(filter, index) in store.activeFilters"
          :key="index"
          class="active-filter btn btn-primary"
          @click.prevent.stop="removeFilter(index)"
        >
          {{ index }}
          <span class="glyphicon glyphicon-remove"></span>
        </button>
      </span>
    </div>

    <Transition name="collapse">
      <div v-show="!current.isCollapsed" class="products-filter">
        <!-- Search Section -->
        <!--      <div class="product-search-popup" v-if="!searchData.disabled">-->
        <!--        <div class="product-search-container">-->
        <!--          <div class="search-icon">-->
        <!--            <span class="bi-search"></span>-->
        <!--          </div>-->
        <!--          <div class="product-search">-->
        <!--            <input-->
        <!--                type="search"-->
        <!--                name="search"-->
        <!--                class="form-control"-->
        <!--                v-model="searchData.query"-->
        <!--                :placeholder="searchData.placeholder || 'Ich suche...'"-->
        <!--            />-->
        <!--          </div>-->

        <!--          <div class="product-search-button">-->
        <!--            <button-->
        <!--                class="btn btn-primary"-->
        <!--                type="submit"-->
        <!--                @click="filterProducts"-->
        <!--            >-->
        <!--              <span v-if="searchData.searchButtonCaption">{{ searchData.searchButtonCaption }}</span>-->
        <!--              <span v-else class="bi-search"></span>-->
        <!--            </button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->

        <!-- Filters Section -->
        <div
          class="product-filters-popup"
          :class="{ open: current.showFilterPopup }"
        >
          <div class="row">
            <div class="product-filters-container" v-if="filterData.attributes?.length > 0">
              <div
                class="product-filter"
                v-for="(attribute, index) in filterData.attributes"
                :key="index"
              >
                <template v-if="!attribute.hidden">
                  <template v-if="attribute.type === 'boolean'">
                    <label :for="'checkbox-' + index">
                      <span class="text-ellipsis">
                        <img
                          v-if="attribute.icon"
                          :src="imageUrl(attribute.icon[0], '')"
                          class="filter-attribute-icon"
                          :alt="attribute.icon[0]?.name"
                        />
                        <span>{{ attribute.title }}</span>
                        <span v-if="attribute.suffix">
                          , <span>{{ attribute.suffix }}</span>
                        </span>
                      </span>
                    </label>

                    <div class="c-input c-checkbox">
                      <input
                        type="checkbox"
                        :id="'checkbox-' + index"
                        :checked="store.appliedFilters[attribute.name]"
                        @change="updateFilter(attribute.name, $event.target.checked)"
                      />
                      <label class="c-indicator" :for="'checkbox-' + index"></label>
                    </div>
                  </template>


                  <div class="mt-1" v-else-if="attribute.type === 'number-slider'">
                    <div class="filter-title tooltipped tooltipped-n"
                         :class="{'filter-disabled': !enabledFilter[attribute.name]}"
                         :aria-label="attribute.title + (attribute.suffix ? ', ' + attribute.suffix : '')">
                      <div class="c-input c-checkbox">
                        <input type="checkbox" :id="'checkbox-' + index" :checked="enabledFilter[attribute.name]"
                               @change="enableFilter(attribute.name, $event.target.checked)"/>
                        <label class="c-indicator" :for="'checkbox-' + index"></label>
                      </div>
                      <span class="text-ellipsis">
                        <img v-if="attribute.icon" :src="imageUrl(attribute.icon[0], '')" class="filter-attribute-icon"
                             :alt="attribute.icon[1]"/>
                        <span>{{ attribute.title }}</span><span v-if="attribute.suffix">,&nbsp;<span>{{
                          attribute.suffix
                        }}</span></span>
                      </span>
                    </div>

                    <div class="input-group input-group-transparent" id="datepicker">
                      <div v-if="!enabledFilter[attribute.name]" @click="enabledFilter[attribute.name] = true"></div>
                      <input type="number"

                             :value="store.appliedFilters[attribute.name]?.length > 0 ? store.appliedFilters[attribute.name][0] : store.initialFilters[attribute.name][0]"
                             :min="attribute.range.min"
                             :max="attribute.range.max" class="form-control" :disabled="!enabledFilter[attribute.name]"
                             @change="updateRangeFilter(attribute.name,0, $event)"/>
                      <span class="input-group-addon">-</span>
                      <input type="number"
                             v-if="store.initialFilters[attribute.name]?.length > 0"
                             :value="store.appliedFilters[attribute.name]?.length > 0 ? store?.appliedFilters[attribute.name][1] : store.initialFilters[attribute.name][1]"
                             :min="attribute.range.min"
                             :max="attribute.range.max" class="form-control" :disabled="!enabledFilter[attribute.name]"
                             @change="updateRangeFilter(attribute.name,1, $event)"/>
                    </div>

                    <div v-if="store.initialFilters[attribute.name]?.length > 0" class="product-filter-slider">
                      <slider
                        :value="store.appliedFilters[attribute.name]?.length > 0 ? store.appliedFilters[attribute.name] : store.initialFilters[attribute.name]"
                        @change="updateFilter(attribute.name,$event)"
                        :min="attribute.range.min"
                        :max="attribute.range.max"
                        :step="1"
                        :tooltips="false"
                        :disabled="!enabledFilter[attribute.name]"
                        :class="['slider-target slider-ltr slider-horizontal slider-txt-dir-ltr',{'slider-disabled': !enabledFilter[attribute.name]}]"
                      />
                    </div>
                  </div>

                  <!--              <div v-else-if="attribute.type === 'number'">-->
                  <!--                <label class="filter-title" :class="{'filter-disabled': !enabledFilter[attribute.name]}" :aria-label="attribute.title + (attribute.suffix ? ', ' + attribute.suffix : '')">-->
                  <!--                  <div class="c-input c-checkbox">-->
                  <!--                    <input type="checkbox" :id="'checkbox-' + index" v-model="enabledFilter[attribute.name]" />-->
                  <!--                    <label class="c-indicator" :for="'checkbox-' + index"></label>-->
                  <!--                  </div>-->
                  <!--                  <span class="text-ellipsis">-->
                  <!--                    <img v-if="attribute.icon" :src="imageUrl(attribute.icon[0], '')" class="filter-attribute-icon" />-->
                  <!--                    <span>{{ attribute.title }}</span><span v-if="attribute.suffix">,&nbsp;<span>{{ attribute.suffix }}</span></span>-->
                  <!--                  </span>-->
                  <!--                </label>-->

                  <!--                <div class="input-group input-group-transparent" id="datepicker">-->
                  <!--                  <div v-if="!enabledFilter[attribute.name]" @click="enabledFilter[attribute.name] = true"></div>-->
                  <!--                  <input type="number" v-model="store.appliedFilters[attribute.name][0]" :min="attribute.range.min" :max="attribute.range.max" class="form-control" :disabled="!enabledFilter[attribute.name]" />-->
                  <!--                  <span class="input-group-addon">-</span>-->
                  <!--                  <input type="number" v-model="store.appliedFilters[attribute.name][1]" :min="attribute.range.min" :max="attribute.range.max" class="form-control" :disabled="!enabledFilter[attribute.name]" />-->
                  <!--                </div>-->

                  <!--                <div class="product-filter-slider">-->
                  <!--                  <slider-->
                  <!--                      v-model="store.appliedFilters[attribute.name][0]"-->
                  <!--                      v-model:high="store.appliedFilters[attribute.name][1]"-->
                  <!--                      :min="attribute.range.min"-->
                  <!--                      :max="attribute.range.max"-->
                  <!--                      :step="1"-->
                  <!--                      :tooltips="false"-->
                  <!--                      :disabled="!enabledFilter[attribute.name]"-->
                  <!--                  />-->
                  <!--                </div>-->
                  <!--              </div>-->

                  <div v-else-if="attribute.type === 'number-input'">
                    <label class="filter-title"
                           :aria-label="attribute.title + (attribute.suffix ? ', ' + attribute.suffix : '')">
                      <span class="text-ellipsis">
                        <img v-if="attribute.icon" :src="imageUrl(attribute.icon[0], '')" class="filter-attribute-icon"
                             :alt="attribute.icon[1]"/>
                        <span>{{ attribute.title }}</span>
                        <span v-if="attribute.suffix">,&nbsp;
                          <span>{{ attribute.suffix }}</span>
                        </span>
                      </span>
                    </label>

                    <span class="input-group input-group-transparent">
                      <input placeholder="From" type="number" :value="attribute.range.min"
                             @change="updateRangeFilter(attribute.name,0, $event)" class="form-control" :debounce="500"/>
                      <span class="input-group-addon">-</span>
                      <input placeholder="To" type="number" :value="attribute.range.max"
                             @change="updateRangeFilter(attribute.name,1, $event)" class="form-control" :debounce="500"/>
                    </span>
                  </div>

                  <div v-else>
                    <label class="tooltipped tooltipped-n"
                           :aria-label="attribute.title + (attribute.suffix ? ', ' + attribute.suffix : '')">
                      <span class="text-ellipsis">
                        <img v-if="attribute.icon" :src="imageUrl(attribute.icon[0], '')" class="filter-attribute-icon"
                        />
                        <span>{{ attribute.title }}</span><span v-if="attribute.suffix">,&nbsp;<span>{{
                          attribute.suffix
                        }}</span></span>
                      </span>
                    </label>
                    <select class="form-control" :value="store.appliedFilters[attribute.name]"
                            @change="updateFilter(attribute.name, $event.target.value)">
                      <option value="">...</option>
                      <option v-for="(value, index) in attribute.values" :key="index" :value="value">{{
                        value
                      }}
                      </option>
                    </select>
                  </div>
                </template>
              </div>
              <div class="product-links-container">
                <ul
                  class="product-links list-inline list-unstyled"
                  v-for="(category, categoryIndex) in filterData.links"
                  :key="categoryIndex"
                >
                  <li>
                    <button @click="filterWith(category.name, '')">All</button>
                  </li>
                  <li v-for="(link, linkIndex) in category.links" :key="linkIndex">
                    <button @click="filterWith(category.name, link)">{{ link }}</button>
                  </li>
                </ul>
              </div>
            </div>

            <div class="product-buttons-container">
              <button
                class="btn btn-primary btn-block"
                type="submit"
                @click="filterProducts"
              >
                <span class="text-ellipsis">
                  <span v-if="store.filterCount">{{ store.filterCount }}&nbsp;</span>
                  <span v-if="filterData.filterButtonCaption">{{ filterData.filterButtonCaption }}</span>
                  <span v-else>Filter</span>
                </span>
              </button>
              <button
                v-if="store.hasActiveFilters"
                class="btn btn-default btn-block"
                type="reset"
                @click="resetFilters"
              >
                <span class="text-ellipsis">
                  <span v-if="filterData.backButtonCaption">{{ filterData.backButtonCaption }}</span>
                  <span v-else>Reset</span>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="current.showFilterPopup"
          class="modal-backdrop fade in"
          @click="current.showFilterPopup = false"
        ></div>
        <div class="clearfix"></div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { reactive, defineProps, watch, ref, onMounted } from 'vue';
import Slider from '@vueform/slider'
import { useProductsStore } from '@/stores/products';
import { imageUrl } from "@/utils/imageUrl";

// Define the 'product' prop, which should be an object
const props = defineProps({
  filterData: {
    type: Object,
    required: true,
  },
});
const store = useProductsStore();

const current = reactive({
  isCollapsed: false,
  showFilterPopup: false,
});

const enabledFilter = reactive({});

function removeFilter(filter) {
  store.removeFilter(filter)
  enableFilter(filter)
  store.filterProducts()
}

function filterProducts() {
  store.applyFilters()
  current.isCollapsed = true
}

function filterWith(name, value) {
  if (value === null) {
    delete store.appliedFilters[name];
  } else {
    store.appliedFilters[name] = value;
  }
}

function enableFilter(filter, event = false) {
  enabledFilter[filter] = event
  if(event === false) {
    store.removeFilter(filter)
    // store.resetFilter({ ...attribute })
    // store.filterProducts()
  }
}

function updateRangeFilter (filter, index, e) {
  store.applyRangeFilter(filter, index, e)
  store.updateAppliedFilters({ [filter]: store.appliedFilters[filter] })
  store.filterProducts()
  store.filterFilters(filter)
}
function updateFilter (filter, value) {
  store.applyCharFilter(filter, value)
  value === '...' ? store.removeFilter(filter) : store.updateAppliedFilters({ [filter]: store.appliedFilters[filter] })
  store.filterProducts()
  store.filterFilters(filter)
}

function resetEnabledFilter() {
  if(Object.keys(enabledFilter).length === 0) {
    return
  }
  for (const filter in enabledFilter) {
    enabledFilter[filter] = false
  }
}

function resetFilters() {
  store.removeFilters()
  resetEnabledFilter()
  // initializeProductFilter()
}

</script>

<style scoped lang="scss">
::v-deep(.slider-disabled .slider-connect, .slider-handle) {
  background-color: #cccccc;
}
::v-deep(.slider-disabled .slider-handle) {
  background-color: #cccccc;
}



</style>
